import * as React from 'react';
import { IFavoritesFolder } from '../../types/favoriteEntity';
import { FoldersListItem } from '../../components/FoldersList/FoldersListItem';
import { Images24 } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedId } from '../../selectors/folders';
import { selectFolder } from '../../actions/folders/actions';
import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { unselectAll } from '../../actions/selected';
import { addQueryToHistory } from '../../hooks/browserHistory';

interface IFoldersListItemContainerProps {
  folder: IFavoritesFolder;
}

export function FoldersListItemContainer({ folder }: IFoldersListItemContainerProps) {
  const dispatch = useDispatch();
  const selectedFolderId = useSelector(selectSelectedId);

  const { imageUrl } = folder;
  const image = imageUrl ? <img src={imageUrl} width={48} height={48} /> : <Images24 color="gray20_100" />;

  const handleClick = () => {
    if (folder.id !== selectedFolderId) {
      addQueryToHistory({ folder: `${folder.id}` });
      dispatch(selectFolder({ folder }));
      dispatch(unselectAll());
      dispatch(fetchFavoriteEntities({ offset: 0 }));
    }
  };

  return (
    <FoldersListItem
      image={image}
      selected={folder.id === selectedFolderId}
      title={folder.name}
      description={folder.description}
      onClick={handleClick}
    />
  );
}
